export default "__VITE_ASSET__DWzFqcSb__"